import { render, staticRenderFns } from "./ImportManualOrderForm.vue?vue&type=template&id=61525b5d&lang=pug"
import script from "./ImportManualOrderForm.vue?vue&type=script&lang=js"
export * from "./ImportManualOrderForm.vue?vue&type=script&lang=js"
import style0 from "./ImportManualOrderForm.vue?vue&type=style&index=0&id=61525b5d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports